import script from "./ObserverHelper.vue?vue&type=script&setup=true&lang=js"
export * from "./ObserverHelper.vue?vue&type=script&setup=true&lang=js"

import "./ObserverHelper.vue?vue&type=style&index=0&id=547c5012&lang=css"

const __exports__ = script;

export default __exports__